import React, { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import cls from './MassActionsPanel.module.css';
import { TypeBlock } from './TypeBlock/TypeBlock';
import { EditBlock } from './EditBlock/EditBlock';
import { CopyBlock } from './CopyBlock/CopyBlock';
import { GroupingBlock } from './GroupingBlock/GroupingBlock';
import { useTranslation } from 'react-i18next';

export const MassActionsPanel = memo(({ classes }) => {
    const { t } = useTranslation();
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [showUngroupButton, setShowUngroupButton] = useState(true);
    const [showGroupButton, setShowGroupButton] = useState(true);
    const [disabledUngroupButton, setDisabledUngroupButton] = useState(false);
    const [disabledGroupButton, setDisabledGroupButton] = useState(false);
    const [activeSelect, setActiveSelect] = useState('');
    const observerRef = useRef(null);

    const $stepBody = $('.estimate-step-body');

    const closePanel = () => {
        positionMassEditManager.uncheckAllPositions('all');
        setSelectedCheckboxes([]);
    };

    const check = () => {
        setShowGroupButton((_) => true);
        setShowUngroupButton((_) => true);
        const $checkboxes = $stepBody.find('input[type="checkbox"]');
        setDisabledUngroupButton(false);
        setDisabledGroupButton(false);
        const selected2 = $checkboxes.filter(function () {
            return $(this).is(':checked');
        });
        let needHideGroup = true;

        let isGroupPosition = false;
        let isSinglePosition = false;

        $.each(selected2, function () {
            const position = $(this).closest('.position.position-dictionary');

            if (!PM.hasParent(position) && !PM.isGroup(position) && !!PM.getGuid(position)) {
                needHideGroup = false;
                isSinglePosition = true;
            }
            if (PM.hasParent(position)) {
                isGroupPosition = true;
            }
        });

        if (selected2.length === $checkboxes.length && !isSinglePosition) {
            setShowUngroupButton(true);
            setShowGroupButton(false);
            setDisabledUngroupButton(false);
            return;
        }

        $.each(selected2, function () {
            const position = $(this).closest('.position.position-dictionary');

            if (!PM.hasParent(position) && !PM.isGroup(position)) {
                setShowUngroupButton(false);
            }
            if (PM.isGroup(position)) {
                setDisabledGroupButton(true);
            }
            if (PM.hasParent(position)) {
                const parent = PM.getParent(position);

                const parentGuid = PM.getGuid(parent);
                let hasParentInChecked = false;
                $.each(selected2, function () {
                    const position = $(this).closest('.position.position-dictionary');

                    if (PM.getGuid(position) === parentGuid) {
                        hasParentInChecked = true;
                    }
                });
                if (!hasParentInChecked) {
                    setDisabledUngroupButton(true);
                }

                if (needHideGroup) setShowGroupButton(false);

                if (!needHideGroup && isGroupPosition) {
                    setDisabledGroupButton(true);
                }
            }
        });
    };

    const updateSelectedCheckboxes = () => {
        const $checkboxes = $stepBody.find('input[type="checkbox"]');
        const selected = $checkboxes
            .filter(function () {
                return (
                    $(this).closest('.position-dictionary.single').length > 0 &&
                    $(this).is(':checked')
                );
            })
            .map((_, checkbox) => checkbox.id)
            .get();

        setSelectedCheckboxes(selected);
    };

    useEffect(() => {
        const $checkboxes = $stepBody.find('input[type="checkbox"]');
        const handleCheckboxChange = () => {
            updateSelectedCheckboxes();
            check();
        };

        $checkboxes.on('change', handleCheckboxChange);
        window.addEventListener('legacy:massEditSelection:changed', handleCheckboxChange);

        handleCheckboxChange();

        observerRef.current = new MutationObserver(() => {
            $checkboxes.off('change', handleCheckboxChange);
            const newCheckboxes = $stepBody.find('input[type="checkbox"]');
            newCheckboxes.on('change', handleCheckboxChange);
            updateSelectedCheckboxes();
        });

        observerRef.current.observe($stepBody[0], { childList: true, subtree: true });

        return () => {
            $checkboxes.off('change', handleCheckboxChange);
            window.removeEventListener('legacy:massEditSelection:changed', handleCheckboxChange);
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
        };
    }, []);
    useEffect(() => {
        const onHideActiveSelect = () => {
            if (activeSelect !== '') {
                setActiveSelect('');
            }
        };

        document.addEventListener('click', onHideActiveSelect);

        return () => {
            document.removeEventListener('click', onHideActiveSelect);
        };
    }, [activeSelect]);

    return (
        <div
            className={classNames(
                cls.MassActionsPanel,
                {
                    [cls.showPanel]: !!selectedCheckboxes.length,
                },
                [classes]
            )}
        >
            <div className={cls.actionGroup}>
                <TypeBlock setActiveSelect={setActiveSelect} activeSelect={activeSelect} />
                <EditBlock setActiveSelect={setActiveSelect} activeSelect={activeSelect} />
                <CopyBlock setActiveSelect={setActiveSelect} activeSelect={activeSelect} />
                <GroupingBlock
                    showGroupButton={showGroupButton}
                    disabledGroupButton={disabledGroupButton}
                    showUngroupButton={showUngroupButton}
                    disabledUngroupButton={disabledUngroupButton}
                    setShowGroupButton={setShowGroupButton}
                    setShowUngroupButton={setShowUngroupButton}
                    setDisabledUngroupButton={setDisabledUngroupButton}
                    setDisabledGroupButton={setDisabledGroupButton}
                />
            </div>
            <div className={cls.totalGroup}>
                <div className={cls.totalGroupItem}>
                    <span className={cls.massCheckPosition}>
                        {t('MassActionsPanel.massCheckPosition.text')}
                    </span>
                    <span className={cls.totalValue}>
                        {selectedCheckboxes.length} {t('MassActionsPanel.totalValuePositions.text')}
                    </span>
                </div>
            </div>
            <div className={cls.close}>
                <button type="button" onClick={closePanel}>
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g opacity="0.7" clipPath="url(#clip0_95_895)">
                            <path
                                d="M4.1074 4.10744C0.854709 7.36013 0.854709 12.6399 4.1074 15.8926C7.36009 19.1452 12.6398 19.1452 15.8925 15.8926C19.1452 12.6399 19.1452 7.36013 15.8925 4.10744C12.6398 0.854752 7.36009 0.854752 4.1074 4.10744ZM12.9462 7.05372C13.2717 7.37916 13.2717 7.9068 12.9462 8.23223L11.1785 10L12.9462 11.7678C13.2717 12.0932 13.2717 12.6208 12.9462 12.9463C12.6208 13.2717 12.0932 13.2717 11.7677 12.9463L9.99996 11.1785L8.23219 12.9463C7.90675 13.2717 7.37912 13.2717 7.05368 12.9463C6.72824 12.6208 6.72824 12.0932 7.05368 11.7678L8.82145 10L7.05368 8.23223C6.72824 7.9068 6.72824 7.37916 7.05368 7.05372C7.37912 6.72828 7.90675 6.72828 8.23219 7.05372L9.99996 8.82149L11.7677 7.05372C12.0932 6.72828 12.6208 6.72828 12.9462 7.05372Z"
                                fill="white"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_95_895">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>
        </div>
    );
});
